/**
 * Utility function to format numbers based on the unit.
 * @param value - The number to format.
 * @param unit - The unit type ("tickets" or "currency").
 * @returns The formatted number as a string.
 */
export const formatNumber = (value: number, unit: string): string => {
  if (unit === "tickets") {
    return `${Math.round(value)} vé`;
  } else if (unit === "currency") {
    return `${value.toLocaleString()} VND`;
  }
  return value.toString();
};

/**
 * Utility function to format date and time.
 * @param dateString - The date string to format.
 * @returns The formatted date and time as a string in `dd/MM/yyyy HH:mm` format.
 */
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  return date.toLocaleDateString('vi-VN', options).replace(',', '');
};
